import { Injectable } from '@angular/core';
import { CanLoad, Router } from '@angular/router';
import { AuthenticationService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanLoad {
  constructor(
    private authService: AuthenticationService,
    private router: Router
  ) {}

  public canLoad() {
    if (!this.authService.hasToken()) {
      return this.router.parseUrl('/welcome-page');
    }

    return true;
  }
}
